import { Component, OnInit, Optional, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClassSetService } from 'src/app/providers/class-set/class-set.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-classset-modal',
  templateUrl: './classset-modal.component.html',
  styleUrls: ['./classset-modal.component.scss']
})
export class ClasssetModalComponent implements OnInit {
 classSetForm: FormGroup;

 local_data: any;
  id: number;
  description: string;
  name: string;

  constructor(public fb: FormBuilder,public dialogRef: MatDialogRef<ClasssetModalComponent>,
    private classSetService: ClassSetService, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) 
  { 
    this.local_data = { ...data };
    this.id = this.local_data.id;

    if (!this.id) {
      this.createForm();
    } else {
      this.editForm();
    }
  }

  createForm() {
    this.classSetForm = new FormGroup({
      name: new FormControl(),
      description: new FormControl()
    });

    this.classSetForm = this.fb.group({
      name: ['', [Validators.required]],
      description: ['', [Validators.required]]
    })
  }

  editForm() {
    this.classSetForm = new FormGroup({
      name: new FormControl(),
      description: new FormControl()
    });

    this.classSetForm = this.fb.group({
      name: [this.data.name, [Validators.required]],
      description: [this.data.description, [Validators.required]]
    })
  }

addClassSet() {
  if (!this.id) {
    console.log(this.classSetForm.value);
    this.classSetService.addClassSet(this.classSetForm.value)
        .pipe(map(
        data => { console.log(data); return data },
        err => { console.log(err); return err }
        ))
        .subscribe(
          data=>{
            return data;
       },
          err=>{alert("Invalid data");console.log(err)}
       );

  }else{
 console.log(this.classSetForm.value);
  this.classSetService.editClassSet(this.id, this.classSetForm.value)
      .pipe(map(
      data => { console.log(data); return data },
      err => { console.log(err); return err }
      ))
      .subscribe(
        data=>{
          return data;
     },
        err=>{alert("Invalid data");console.log(err)}
     );
  }
 
    
  }

onNoClick(): void {
  this.dialogRef.close();
}
ngOnInit(): void {
}

}
